import React from "react";
import Image from "@herb/components/Image";
import { trackTransferToShop, trackSelectPromotion } from "../../../utils/analytics";
import "./index.css";

const ProductCard = ({ deal }) => {
  const { title } = deal;
  const content = deal?.contentDeals?.contentDeals;
  const { product, dealLink } = content || {};
  const productImage =
    product?.contentProducts?.productImages?.[0]?.sourceUrl ||
    product?.images?.[0] ||
    "";

  return (
    <div className="product-card">
      <div className="image-container">
        <Image
          src={productImage}
          className="product-image"
          alt="Product"
        />
      </div>

      <div className="product-details">
        <img
          src="https://herb-platform-images.imgix.net/wp-content/uploads/2025/03/18103834/dealProductBg.png"
          className="product-details-bg"
        />
        <div className="product-details-div">
          <p className="product-category">{product?.category}</p>
          <p className="brand-name">{product?.brand_name}:</p>
          <h3 className="product-title">{product?.title}</h3>
          <a
            className="shop-button"
            href={dealLink}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              // Track promotion selection (420 deals are seasonal)
              trackSelectPromotion({
                promotionName: product?.title || title,
                dealType: 'seasonal_420',
                brand: product?.brand_name || '',
                category: product?.category || ''
              });
              
              // Track transfer to shop
              trackTransferToShop({
                affiliateUrl: dealLink,
                contentType: 'deals_page',
                surfaceType: 'deal_card',
                productTitle: product?.title,
                category: product?.category || '',
                brand: product?.brand_name || ''
              });
            }}
          >
            SHOP NOW
          </a>
        </div>
      </div>
    </div>
  );
};

export { ProductCard };
